export const SHIPMENT = 'Shipment';
export const ShipmentStatusValues = [
    'draft',
    'posted',
    'cancelled',
];
export const SHIPMENT_STATUS_LABELS = {
    draft: 'Rascunho',
    posted: 'Efetivado',
    cancelled: 'Cancelado',
};
//# sourceMappingURL=shipment.js.map